document.documentElement.classList.add("tw-js");

document.addEventListener("DOMContentLoaded", function () {
  var blocksToAnimate = document.querySelectorAll(".tw-block-animation");
  if (!blocksToAnimate.length) {
    return;
  }

  if (!("IntersectionObserver" in window)) {
    document.documentElement.classList.add("tw-io-disabled");
    for (var i = 0; i < blocksToAnimate.length; i++) {
      blocksToAnimate[i].classList.add("animated");
    }
    return;
  }

  var options = {
    rootMargin: "0px 0px -80px 0px",
    threshold: 0,
  };

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add("animated");
        observer.unobserve(entry.target);
      }
    });
  }, options);

  for (var i = 0; i < blocksToAnimate.length; i++) {
    observer.observe(blocksToAnimate[i]);
  }
});
